import {Plans} from "./plans.enum";
import {IBusinessContractLimits} from "./business-contract.interface";
import {IBusinessConfigurations} from "../client-site";

export const limitsByPlan: Record<Plans, IBusinessContractLimits & Pick<IBusinessConfigurations, 'numOfClientsAllowed'>> = {
  [Plans.FREE]: {
    sms: 100,
    whatsapp: 100,
    numOfClientsAllowed: 1,
    numOfAppointments: 25
  },
  [Plans.PREMIUM]: {
    sms: 1000,
    whatsapp: 250,
    numOfClientsAllowed: 3,
  },
}
